import { InstructionSortField } from "@/graphql/codegen/graphql"

export type InstructionSortableAccessorKey = "name" | "isHazard" | "applicableTo" | "transportationMode" | "includeWith"

export const accessorKeyToInstructionSortField = new Map<InstructionSortableAccessorKey, InstructionSortField>([
  ["name", InstructionSortField.Name],
  ["applicableTo", InstructionSortField.ApplicableTo],
  ["transportationMode", InstructionSortField.TransportationMode],
  ["includeWith", InstructionSortField.IncludeWith],
  ["isHazard", InstructionSortField.IsHazard],
])

export const instructionSortFieldToAccessoryKey = new Map<InstructionSortField, InstructionSortableAccessorKey>([
  [InstructionSortField.Name, "name"],
  [InstructionSortField.ApplicableTo, "applicableTo"],
  [InstructionSortField.TransportationMode, "transportationMode"],
  [InstructionSortField.IncludeWith, "includeWith"],
  [InstructionSortField.IsHazard, "isHazard"],
])
